import { CarWheelSetSeasonDistribution, TireSeason, TireSeasonLabels } from '@navio/nsdk';
import { DashboardPieChart, shadCnColors } from 'noddi-ui-web';
import { getWheelSetSeasonCount, STORED_WHEEL_SET_SEASONS } from './wheelSetSeasonCounts';

const SEASON_COLOR: Record<(typeof STORED_WHEEL_SET_SEASONS)[number], string> = {
  [TireSeason.SUMMER]: shadCnColors.yellow[400],
  [TireSeason.WINTER]: shadCnColors.blue[300]
};

const TIRES_SLICE = 'tires';

type Props = {
  counts: CarWheelSetSeasonDistribution[];
  /** Loose tires at the location, drawn as their own slice. */
  tireCount?: number;
  description?: string;
  isLoading?: boolean;
};

export const StoredWheelSetsChart = ({ counts, tireCount = 0, description, isLoading }: Props) => (
  <DashboardPieChart
    title='Stored items'
    description={description}
    isLoading={isLoading}
    data={[
      ...STORED_WHEEL_SET_SEASONS.map((season) => ({
        name: `${TireSeasonLabels[season]} wheel sets`,
        value: season,
        count: getWheelSetSeasonCount(counts, season),
        color: SEASON_COLOR[season]
      })),
      { name: 'Tires', value: TIRES_SLICE, count: tireCount, color: shadCnColors.violet[300] }
    ].filter(({ count }) => count > 0)}
    emptyStateTitle='Nothing stored'
  />
);
